import zwitCore from "./config/http";
import axios from "axios";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
  // 根据手机号查学者信息
  phoneGetUserinfo(phone) {
    return zwitCore.HTTP.get(
      BASE_URL + `/zw-user/scholar/getScholarInfo/${phone}`,
      { phone },
      false
    );
  },
  // 获取根据手机号userID
  isExist(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/user/nf/account/isExist",
      data,
      false
    );
  },
  // async isExist(data) {
  //   return await axios({
  //     url: `${BASE_URL}/zw-user/user/nf/account/isExist`,
  //     method: "post",
  //     data,
  //     headers: {
  //       rsa: "no",
  //     },
  //   });
  // },
  // 获取会议门票
  getSignUpInfo(data) {
    console.log("id:", data);
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/meetingSignUp/signUpInfo",
      data,
      false
    );
  },
  // 报名会议
  async setSignUp(data) {
    return await axios({
      url: `${BASE_URL}/zw-information/meetingSignUp/signUp`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  getUserMessageMrgList(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getInformationList",
      data,
      false
    );
  },
  downId(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleInfo/closeFile",
      data,
      false
    );
  },
  delId(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleInfo/deleteArticle",
      data,
      false
    );
  },
  // 个人中心退领接口
  withdrawalArticle(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserCore/nf/withdrawalArticle",
      data,
      false
    );
  },
  delmeetingById(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/del",
      data,
      false
    );
  },
  getUserContentMrgList(data) {
    console.log("查询参数:", data);
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getThesisList",
      data,
      false
    );
  },
  getUserCenterPage(data) {
    console.log(data, "data");
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleMeeting/userCenterPage",
      data,
      false
    );
  },
  getCurriculumList(data) {
    console.log(data, "data");
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getCurriculumList",
      data,
      false
    );
  },

  science() {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserCore/getUserChannelList",
      {},
      false
    );
  },
  // 获取用户模块-》学术专著
  /* {
  "content":{},
  "data":[
    {
      "channel1Id":"6",
      "channel1Name":"学术专著",
      "projectId":1
    }
  ],
  "messageType":"Success",
  "resultCode":"200",
  "resultDesc":"成功!"
} */
  monograph(parmas) {
    console.log("查询参数:", parmas);
    return zwitCore.HTTP.get(
      BASE_URL + `/zw-knowledge/column/columnListByType?type=${parmas}`,
      {},
      false
    );
  },
  asyncFamilies(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/syncArticle",
      data,
      false
    );
  },
  // 撤回百家号展示
  withdraw(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/syncDelArticle",
      data,
      false
    );
  },
  apply(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleApplyColumn/getColumnList",
      data,
      false
    );
  },
  setStatus(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleApplyColumn/applyColumn",
      data,
      false
    );
  },
  browseList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-admin/history/browse",
      data,
      false
    );
  },
  dwonList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-admin/history/download",
      data,
      false
    );
  },
  async webSave(data) {
    return await axios({
      url: `${BASE_URL}/zw-information/articleInfo/websave`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  async conferenceSave(data) {
    return await axios({
      url: `${BASE_URL}/zw-information/articleMeeting/add`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  async conferenceUpdate(data) {
    return await axios({
      url: `${BASE_URL}/zw-information/articleMeeting/upd`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  // 征稿函提交修改
  async addLetter(data) {
    return await axios({
      url: `${BASE_URL}/zw-knowledge/solicitation/addLetter`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  getLetter(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/solicitation/detail",
      data,
      false
    );
  },
  setSonPwd(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/reset/nf/subUserUpdatePwd",
      data,
      false
    );
  },
  getTreeList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/column/treeList",
      data,
      false
    );
  },
  paperList(data) {
    console.log("论文参数:", data);
    //期刊论文
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getUserThesis0List",
      data,
      false
    );
  },
  PatentsList(data) {
    //专利
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getUserPatentList",
      data,
      false
    );
  },
  concentrationList(data) {
    //专著
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getUserMonographList",
      data,
      false
    );
  },
  ResearchList(data) {
    //科技报告
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getUserTechnologyReportList",
      data,
      false
    );
  },
  achievementList(data) {
    //会议成果
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getUserThesis1List",
      data,
      false
    );
  },
  standardList(data) {
    //标准
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getUserStandardList",
      data,
      false
    );
  },
  restsList(data) {
    //其他
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getUserThesis4List",
      data,
      false
    );
  },
  userDetails() {
    return zwitCore.HTTP.json(BASE_URL + "/zw-user/getUserDetail", {}, false);
  },
  systemMsg(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/msg/nf/sysMessageList",
      data,
      false
    );
  },
  systemMsg1(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/message/nf/sysMessageList",
      data,
      false
    );
  },
  // systemMsg1(data) {
  //   return zwitCore.HTTP.get(
  //     BASE_URL + "/zw-user/message/nf/sysMessageList",
  //     data,
  //     false
  //   );
  // },
  // 收藏管理 // 咨询列表
  getUserCollectInformationList(data) {
    return zwitCore.HTTP.get(
      BASE_URL +
        "/zw-information/articleUserCore/nf/getUserCollectInformationList",
      data,
      false
    );
  },
  // 收藏课程管理
  getUserCollectCurriculumList(data) {
    return zwitCore.HTTP.get(
      BASE_URL +
        "/zw-information/articleUserCore/nf/getUserCollectCurriculumList",
      data,
      false
    );
  },

  // 收藏管理 文献列表
  getUserCollectThesisList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserCore/nf/getUserCollectThesisList",
      data,
      false
    );
  },
  // 收藏管理，征稿函列表
  getUserCollectSolicitationList(data) {
    return zwitCore.HTTP.get(
      BASE_URL +
        "/zw-information/articleUserCore/nf/getUserCollectSolicitationList",
      data,
      false
    );
  },
  // 收藏管理，会议列表
  getUserCollectMeetingList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/collectList",
      data,
      false
    );
  },
  // 查询文章发布作者
  findAuthorInfoByNameAndCompany(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/searchUser/nf/findAuthorInfoByNameAndCompany",
      data,
      false
    );
  },
  // 查询文章发布作者单位
  getUnitList(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/scholar/nf/getUnitList",
      data,
      false
    );
  },
  setPwd(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/reset/userResetPwd",
      data,
      false
    );
  },
  setPhone(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/reset/userResetAccountPwd",
      data,
      false
    );
  },
  getUserGroupList(data) {
    return zwitCore.HTTP.post(BASE_URL + "/zw-user/role/roleList", data, false);
  },
  getUserList(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/subUser/subUserList",
      data,
      false
    );
  },
  addUserGroup(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/subUser/linkUser2Role",
      data,
      false
    );
  },
  removePwd(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/reset/subUserResetPwd",
      data,
      false
    );
  },
  deleteUser(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/subUser/delSubUser",
      data,
      false
    );
  },
  createUserGroup(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/role/createRole",
      data,
      false
    );
  },
  createUser(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/subUser/create",
      data,
      false
    );
  },
  deleteUserGroup(data) {
    return zwitCore.HTTP.post(BASE_URL + "/zw-user/role/delRole", data, false);
  },
  getJurisdiction(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/subUser/getRationPermissionList",
      data,
      false
    );
  },
  setJurisdiction(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/subUser/addPermissionOfRole",
      data,
      false
    );
  },
  userAndUserGroup(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/subUser/linkUser2Role",
      data,
      false
    );
  },
  // 资金类型列表
  fundTypeList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/fundType/fundTypeList", {});
  },
  // 基金列表
  page(data) {
    return zwitCore.HTTP.json(BASE_URL + "/zw-public/fund/page", data, false);
  },
  // 添加基金
  addFund(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleFund/addFund",
      data,
      false
    );
  },
  // 学科列表
  getSubjectList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/subject/getList", {});
  },
  // 行业分类一级列表
  getOneLists() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/industry/getOneList", {});
  },
  // 行业分类二级列表
  getTwoLists(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/industry/getListByPid",
      data
    );
  },
  getOrDetails() {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/org/nf/selfDetail",
      {},
      false
    );
  },
  getMaDetails() {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/periodical/selfDetail",
      {},
      false
    );
  },
  getexperience() {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/nf/experience",
      {},
      false
    );
  },

  commitEduExperience(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/scholar/commitEduExperience",
      data,
      false
    );
  },

  commitWorkExperience(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/scholar/commitWorkExperience",
      data,
      false
    );
  },
  commitTitleExperience(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/scholar/commitTitleExperience",
      data,
      false
    );
  },
  commitMoonLightingExperience(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/scholar/commitMoonLightingExperience",
      data,
      false
    );
  },
  delEduExperience(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/delEduExperience",
      data,
      false
    );
  },
  delWorkExperience(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/delWorkExperience",
      data,
      false
    );
  },
  delTitleExperience(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/delTitleExperience",
      data,
      false
    );
  },
  elMoonLightingExperience(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/delMoonLightingExperience",
      data,
      false
    );
  },
  levelOne() {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/title/getOneList",
      {},
      false
    );
  },
  levelTwo(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/title/getTwoList",
      data,
      false
    );
  },
  levelThree(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/title/getThreeList",
      data,
      false
    );
  },
  getOneList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/researchField/getOneList",
      data,
      false
    );
  },
  getTwoList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/researchField/getTwoList",
      data,
      false
    );
  },
  getThreeList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/researchField/getThreeList",
      data,
      false
    );
  },
  async setUserInfo(data) {
    return await axios({
      url: `${BASE_URL}/zw-user/scholar/modifyBaseInfo`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
    // return zwitCore.HTTP.json(
    //   BASE_URL + "/zw-user/scholar/modifyBaseInfo",
    //   data,
    //   false
    // );
  },
  async setMaInfo(data) {
    console.log(data);
    return await axios({
      url: `${BASE_URL}/zw-user/periodical/update`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  setPeriodicalIntro(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/periodical/updateIntro",
      data,
      false
    );
  },
  setPeriodicalNotice(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/periodical/updateNotice",
      data,
      false
    );
  },
  async subPeriodical(data) {
    console.log(data);
    return await axios({
      url: `${BASE_URL}/zw-user/periodical/auth`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  async subscholar(data) {
    console.log(data);
    return await axios({
      url: `${BASE_URL}/zw-user/scholar/authScholar`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  // 期刊认证
  async organizationCertification(data) {
    console.log(data);
    return await axios({
      url: `${BASE_URL}/zw-user/org/submitAuth`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  // 机构认证审核信息
  async getOrganizationCertificationDetail() {
    return await axios({
      url: `${BASE_URL}/zw-user/org/authInfo`,
      method: "get",
      data: {},
    });
  },

  // setMaInfo(data){
  //   console.log(data,'data');
  //   return zwitCore.HTTP.json(
  //   BASE_URL + "/zw-user/periodical/update",
  //   data,
  //   false
  // );
  // },
  setImg(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/org/changeCompany",
      data,
      false
    );
  },
  setName(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/org/updateOrgInfo",
      data,
      false
    );
  },

  modifyEduExperience(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/scholar/modifyEduExperience",
      data,
      false
    );
  },
  modifyMoonLightingExp(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/scholar/modifyMoonLightingExp",
      data,
      false
    );
  },
  modifyTitleExperience(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/scholar/modifyTitleExperience",
      data,
      false
    );
  },
  modifyWorkExperience(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/scholar/modifyWorkExperience",
      data,
      false
    );
  },
  getwenzhai(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getUserThesis3List",
      data,
      false
    );
  },
  getHYBG(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleUserCore/getUserReportList",
      data,
      false
    );
  },
  // 回显
  getEcho(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleInfo/getDetails",
      data,
      false
    );
  },
  // 修改文章回显
  getDetailsByUser(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleInfo/getDetailsByUser",
      data,
      false
    );
  },
  // 会议详情
  getMeeting(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/detail",
      data,
      false
    );
  },
  // 会议发布修改详情回显
  getMeetingDetailById(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/detailById",
      data,
      false
    );
  },
  userEditType() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-user/scholar/baseInfo", {}, false);
  },
  userEditTypes() {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/nf/authStatus",
      {},
      false
    );
  },
  msgDetails(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/message/nf/sysMessageDetail",
      data,
      false
    );
  },
  proList() {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/area/getProvince",
      {},
      false
    );
  },
  cityList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/area/zw-public/area/getCity",
      data,
      false
    );
  },
  zghList(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-knowledge/solicitation/myPage",
      data,
      false
    );
  },
  zghxz(data) {
    return zwitCore.HTTP.patch(
      BASE_URL + "/zw-knowledge/solicitation/letterDown",
      data,
      false
    );
  },
  zghdel(data) {
    return zwitCore.HTTP.delete(
      BASE_URL + "/zw-knowledge/solicitation/delLetter",
      data,
      false
    );
  },
  // 分类
  listByType(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/videoOrg/listByType",
      data,
      false
    );
  },
  // 栏目
  projectAndColumnListByType(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/column/projectAndColumnListByType",
      data,
      false
    );
  },
  getCollectionList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleVideo/collectionList",
      data,
      false
    );
  },
  // 提交意见反馈
  subFeedback(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/feedback/nf/commit",
      data,
      false
    );
  },
  // 意见反馈列表
  feedbackList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/feedback/nf/list",
      data,
      false
    );
  },
  // 意见反馈详情
  feedbackDetail(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/feedback/nf/detail",
      data,
      false
    );
  },
  // 分片上传
  uplodeChunk(data) {
    return zwitCore.HTTP.postFormData(
      BASE_URL + "/zw-public/uploader/nf/chunk",
      data,
      false
    );
  },
  // 判断分片是否都上传完成
  uplodeIsChunk(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/uploader/nf/chunk",
      data,
      false
    );
  },
  // 分片文件合并
  uplodeMergeFile(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-public/uploader/nf/mergeFile",
      data,
      false
    );
  },
  uplodeCheckMerge(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-public/uploader/nf/checkMerge",
      data,
      false
    );
  },
  //查询用户认证状态
  authStatus(type) {
    return zwitCore.HTTP.get(
      BASE_URL + `/zw-user/user/authStatus/${type}`,
      {},
      false
    );
  },
  // //编辑履历
  // addOrEditExperience(data) {
  //   console.log('个人履历参数:',data)
  //   return zwitCore.HTTP.json(
  //     BASE_URL + "/zw-user/scholar/nf/addOrEditExperience",
  //     data,
  //     false
  //   );
  // }
  //编辑个人履历
  async addOrEditExperience(data) {
    console.log("个人履历参数:", data);
    return await axios({
      url: `${BASE_URL}/zw-user/scholar/nf/addOrEditExperience`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  //编辑获奖情况
  async addOrEditPrize(data) {
    console.log("获奖情况参数:", data);
    return await axios({
      url: `${BASE_URL}/zw-user/scholar/nf/addOrEditPrize`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  // 获取获奖情况
  getPrizeInfo(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/nf/prizeInfo",
      data,
      false
    );
  },

  // 公共获取个人简介
  spaceScholarProfile(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/nf/spaceScholarProfile",
      data,
      false
    );
  },
  // 公共获取教育背景
  spaceScholarEduExp(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/nf/spaceScholarEduExp",
      data,
      false
    );
  },
  // 公共获取工作经历
  spaceScholarWorkExp(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/nf/spaceScholarWorkExp",
      data,
      false
    );
  },
  // 公共获取职称经历
  spaceScholarTitleExp(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/nf/spaceScholarTitleExp",
      data,
      false
    );
  },
  // 公共获取社会任职
  spaceScholarMoonExp(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/nf/spaceScholarMoonExp",
      data,
      false
    );
  },
  // 公共获取获奖情况
  spaceScholarPrize(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/scholar/nf/spaceScholarPrize",
      data,
      false
    );
  },
  // 判断个人履历是否隐藏
  getPrivacyList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/privacy/nf/getPrivacyList",
      data,
      false
    );
  },
  // 资讯预览获取articleId串
  setPreview(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserCore/nf/setPreview",
      data,
      false
    );
  },
  // 资讯预览获取数据
  articlePreview(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserCore/nf/articlePreview",
      data,
      false
    );
  },
  getSonDetails(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/statistics/getStatistics",
      data,
      false
    );
  },
  isNameExist(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/periodical/nf/isNameExist",
      data,
      false
    );
  },
  journalOptions(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/periodical/nf/fuzzy/query/list",
      data,
      false
    );
  },
  getRelationList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/researchField/getRelationList",
      data,
      false
    );
  },
  getTitleList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/title/getTitleList",
      data,
      false
    );
  },
  addUnclaimedScholar(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-user/scholar/nf/addUnclaimedScholar",
      data,
      false
    );
  },
  meetingEditPage(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-chat/editing_card/meetingEditPage",
      data,
      false
    );
  },
  getInsertInfo(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/getInsertInfo",
      data,
      false
    );
  },
  addMeetingVideoImg(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleMeeting/addMeetingVideoImg",
      data,
      false
    );
  },
  getMeetingImgList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/getMeetingVideoImgList",
      data,
      false
    );
  },
  getSignUpList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/getSignUpList",
      data,
      false
    );
  },
  cancelSign(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/meetingSignUp/cancel",
      data,
      false
    );
  },
  delImgVideo(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/delImgVideo",
      data,
      false
    );
  },
  updImgVideo(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleMeeting/updImgVideo",
      data,
      false
    );
  },

  myTicketMeetingList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/meetingSignUp/meetingList",
      data,
      false
    );
  },
  myTicketList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/meetingSignUp/ticketList",
      data,
      false
    );
  },
  getMySignUpList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/getMySignUpList",
      data,
      false
    );
  },
  checkUser(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/meetingSignUp/checkUser",
      data,
      false
    );
  },
  // 获取学历
  getEducation(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-public/code/getEduDictionary",
      data,
      false
    );
  },
  getPartnerDetail() {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/partner/nf/detail",
      {},
      false
    );
  },
  // 校验域名是否可用
  checkUrl(data) {
    return zwitCore.HTTP.get(
      BASE_URL + `/zw-groupsite/zwSite/check/${data}`,
      {},
      false
    );
  },
};
